import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  num: '1',
  title: 'Identifica',
  desc: "Reconoce el 'aura' o los primeros síntomas de la crisis antes de que escale."
}, {
  num: '2',
  title: 'Aplica',
  desc: 'Ejecuta el ciclo C-P-C (Frío en nuca + Presión en puntos gatillo).'
}, {
  num: '3',
  title: 'Recupera',
  desc: 'Recupera tu funcionalidad y sigue con tu día en menos de 20 minutos.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-navy-800" data-id="element-99">
      <div className="max-w-5xl mx-auto" data-id="element-100">
        <FadeIn data-id="element-101">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-102">
            Cómo Funciona en la Práctica
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-103">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-slate-700 z-0" data-id="element-104" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-105">
              <div className="flex flex-col items-center text-center" data-id="element-106">
                <div className="w-24 h-24 rounded-full bg-navy-900 border-4 border-teal-500 flex items-center justify-center mb-6 shadow-lg shadow-teal-900/20" data-id="element-107">
                  <span className="font-serif text-4xl font-bold text-teal-400" data-id="element-108">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-109">
                  {step.title}
                </h3>
                <p className="text-slate-400" data-id="element-110">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}